export default __webpack_public_path__ + "static/media/adImg3.f78e1911.jpg";